<template>
  <div class="page-wrapper">
    <h1>Транзакции</h1>
    <transactions-list/>
  </div>
</template>

<script>
  import TransactionsList from '@/TransactionsList';
  
  export default {
    name: 'UserTransactionView',
    components: {
      TransactionsList
    }
  };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/views/UserTransactionsView.vue